import CalcButton from "./CalcButton/CalcButton";
import Display from "./Display/Display";
import "./calculator.css";

function Calculator() {
    return (<>
        <div className="calculator" >
            <div>
                <Display></Display>
            </div>
            <div>
                <CalcButton></CalcButton>
            </div>

        </div>

    </>);


}
export default Calculator